export default __webpack_public_path__ + "static/media/south-america.5385f27b.svg";